import type { RequestParams } from '../requests/http-client';
import { HttpClient } from '../requests/http-client';
import type { BaseErrorResponse, Cs2EventFilterVM } from './data-contracts';


export default function useEventFilter() {
  class EventFilter<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags EventFilter
     * @name EventFilterControllerGetEventFilters
     * @summary Returns a list of event filters
     * @request GET:/cs2/event-filter
     * @secure
     * @response `200` `(Cs2EventFilterVM)[]`
     * @response `400` `BaseErrorResponse`
     */
    eventFilterControllerGetEventFilters = (params: RequestParams = {}) =>
      this.request<Cs2EventFilterVM[], BaseErrorResponse>({
        path: '/cs2/event-filter',
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      });
  }

  return new EventFilter();
}
